// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"App_loadingSpinner__mDfBX","loading":"App_loading__3Rsj5"};